<template>
  <v-menu v-model="value" offset="4">
    <template #activator="{ props }">
      <div v-if="slots.activator" v-bind="props">
        <slot name="activator" />
      </div>
      <e-btn v-else icon variant="ghost" size="S" v-bind="props">
        <e-icon name="dots" size="24" />
      </e-btn>
    </template>

    <v-card class="pa-2">
      <slot />
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import { EBtn, EIcon } from '@/core/components/ui';

defineProps<{
  modelValue?: boolean;
}>();

const value = defineModel<boolean>();

const slots = defineSlots<{
  default: (props: unknown) => void;
  activator?: (props: unknown) => void;
}>();
</script>

<style scoped lang="scss"></style>
